<template>
	<div>
		<div class="list-container">
			<table class="table-list table-header">
				<thead>
					<tr>
						<th style="width:65px;">序号</th>
						<th style="width:100px;">张号</th>
						<th style="width:100px;">位置(m)</th>
						<th style="width:100px;">联号</th>
						<th style="width:100px;">检测面</th>
						<th style="width:100px;">缺陷类型</th>
						<th style="width:100px;">
							面积(mm
							<sup>2</sup>)
						</th>
						<th style="width:100px;">强度</th>
						<th>判定</th>
						<th>标记</th>
					</tr>
				</thead>
			</table>
			<div class="table-container" id="defect_list_table" tabindex="1" @touchmove.prevent @focus="tableFocus" @blur="tableBlur">
				<table class="table-list noselect" id="defect_data_table">
					<tbody>
						<tr
							v-for="(item, index) in dataList"
							v-bind:class="{
								active: selectedIndex == index,
								checked: item.checked,
								good: item.status,
								bad: !item.status,
							}"
							v-bind:key="index"
							v-bind:id="'tr_' + index"
							v-bind:index="10 + index"
							v-on:click="rowClick(item, index)"
						>
							<td style="width:65px;" class="index">
								<label>
									<input type="checkbox" v-model="item.checked" v-bind:index="10 + index" v-bind:id="'chk_' + index" />
									{{ index + 1 }}
								</label>
							</td>
							<td style="width:100px;" v-text="item.sheet_index"></td>
							<td style="width:100px;" v-text="(item.meter / 1000).toFixed(2)"></td>
							<td style="width:100px;" v-text="item.col"></td>
							<td style="width:100px;" v-text="getModelSideText(item.side_index)"></td>
							<td style="width:100px;" v-text="getDefectTypeName(item.type_index, item.type_index_sys)"></td>
							<td style="width:100px;" v-text="(item.area / 1000).toFixed(2)"></td>
							<td style="width:100px;" v-text="item.energy"></td>
							<td v-text="item.status ? '好品1' : '坏品1'" style="width:100px;"></td>
							<td v-text="item.filter_remark"></td>
						</tr>
					</tbody>
				</table>
			</div>

			<div v-show="loading" class="loading">数据加载中...</div>
		</div>
		<defectListControl :style="heightWindous" class="control-container" v-bind:modelSides="modelSides" v-bind:defectTypes="defectTypes" v-bind:goodCount="goodCount" v-bind:badCount="badCount" v-bind:batchInfo="batchInfo" v-on:selectAll="selectAll" v-on:ineligible="ineligible" v-on:eligible="eligible" v-on:changeType="changeType" v-on:changeStatus="changeStatus" v-on:changeSurface="changeSurface" v-on:changeFilterStatus="changeFilterStatus" />
	</div>
</template>

<script>
	import DefectListControl from './ControlCheck'
	import { getDefectRequest } from '../../network/requests/defect'
	import { defectTypeRequest } from '../../network/requests/defectType'
	var _tempOffsetTop = 0

	export default {
		components: {
			DefectListControl,
		},
		props: {
			/**
			 * 表格高度
			 */
			tableHeight: {
				type: Number,
				required: false,
			},
			/**
			 * 框选区域
			 */
			selectionArea: {
				type: Array,
				required: false,
			},
			batch_id: {
				type: String,
			},
			items: {
				type: Array,
			},
			modelSides: {
				type: Array,
			},
			/**
			 * 批次信息。
			 */
			batchInfo: {
				type: Object,
			},
		},
		data() {
			this.firstLoad = false
			return {
				heightWindous: document.body.clientHeight - 350,
				pageIndex: 1,
				pageSize: 1000,
				totalCount: 0,
				dataTableHeight: 0,
				selectedIndex: -1,
				loading: false,
				type: -1,
				status: '',
				tempDataNoSelection: [],
				tableName: this.$route.query.fdefectTableName,
				dataList: [],
				tableDom: null,
				rollDefectTypes: [],
			}
		},
		computed: {
			goodCount() {
				return this.items.filter(t => t.status == 1).length
			},
			badCount() {
				return this.items.filter(t => t.status == 0).length
			},
			defectTypes() {
				var list = []
				if (this.rollDefectTypes.length > 0) {
					this.rollDefectTypes.forEach((v, i) => {
						var count = this.items.filter(t => t.type_index == v.type_index).length
						if (count > 0) {
							if (list.findIndex(t => t.name == v.name) == -1) {
								list.push({
									label: v.display,
									value: v.type_index,
								})
							}
						}
					})
				}

				return list
			},
		},
		watch: {
			/**
			 * 选择表格行的时候触发行点击事件。
			 */
			selectedIndex(val) {
				var row = this.dataList[val]
				this.$emit('rowClick', row)

				console.log('selectedIndex', val)
			},
			/**
			 * 框选时触发操作，重新加载选择区域内的数据。
			 */
			selectionArea(array) {
				//选择的时候需要清空已有的数据。
				this.dataList = []
				this.pageIndex = 1

				console.log('selection area', array)

				if (array[0] == '' || array[1] == '' || array[2] == '' || array[3] == '') {
					//只是点击清空事件，加载上一次没有坐标信息的数据，方便快速加载。
					this.dataList = this.tempDataNoSelection
				} else {
					//重新加载。
					this.initData()
				}
			},
			items: {
				handler() {
					if (this.firstLoad) {
						this.initData()
					}
				},
				deep: true,
			},
		},
		methods: {
			getFilter() {
				var filter = new Object()

				//缺陷状态。
				if (this.status == 'good') {
					filter.status = 1
				} else if (this.status == 'bad') {
					filter.status = 0
				}

				//缺陷类型。
				if (this.type > -1) {
					filter.type_index = this.type
				}

				if (this.selectionArea[0] && this.selectionArea[1] && this.selectionArea[2] && this.selectionArea[3]) {
					var x1 = parseInt(this.selectionArea[0])
					var y1 = parseInt(this.selectionArea[1])
					var x2 = parseInt(this.selectionArea[2])
					var y2 = parseInt(this.selectionArea[3])

					filter.pos_x = { $gt: x1, $lt: x2 } //,
					filter.pos_y = { $gt: y1, $lt: y2 }
				}

				var count = 0
				for (var i in filter) {
					if (Object.prototype.hasOwnProperty.call(filter, i)) {
						count++
					}
				}

				if (count == 0) {
					filter = undefined
				}

				return filter
			},
			getFilter2(item) {
				var result = true
				//缺陷状态。
				if (this.status == 'good') {
					result = item.status == 1
				} else if (this.status == 'bad') {
					result = item.status == 0
				}

				//缺陷类型。
				if (this.type > -1) {
					result &= item.type_index == this.type
				}

				if (this.selectionArea[0] && this.selectionArea[1] && this.selectionArea[2] && this.selectionArea[3]) {
					var x1 = parseFloat(this.selectionArea[0])
					var y1 = parseFloat(this.selectionArea[1])
					var x2 = parseFloat(this.selectionArea[2])
					var y2 = parseFloat(this.selectionArea[3])

					result &= item.pos_x > x1 && item.pos_x < x2
					result &= item.pos_y > y1 && item.pos_y < y2
				}

				return result
			},
			/**
			 * 加载缺陷记录数据。
			 */
			initData() {
				this.dataList = this.items.filter(this.getFilter2)
				//如果请求参数中没有选择区域坐标位置信息，则把该记录记录下来，以便下载点击空白区域的时候加载所有数据时用。
				if (!this.selectionArea[0] || !this.selectionArea[1] || !this.selectionArea[2] || !this.selectionArea[3]) {
					this.tempDataNoSelection = this.dataList
				}

				//选中第一行。
				if (this.firstLoad) {
					if (this.dataList.length > 0) this.rowClick(this.dataList[0], 0)
					this.firstLoad = false
				}

				//this.$emit('loadComplete', this.dataList)
				this.loading = false

				//console.log('缺陷列表加载完成', this.dataList)
			},
			/**
			 * 选择行。
			 */
			rowClick(row, index) {
				this.selectedIndex = index

				// 判断shift是否按下，使用shift进行批量选中。
				if (event) {
					if (event.shiftKey) {
						if (event.shiftKey == 1) {
							row.checked = !row.checked
							//this.dataList.splice(index, 1, row)
							this.datalist[index] = row
						}
					}
				}
			},
			/**
			 * 全选。
			 * @param {Boolean} value 选中还是取消
			 */
			selectAll(value) {
				var tempArray = []
				this.dataList.forEach(item => {
					item.checked = value
					tempArray.push(item)
				})

				this.dataList = tempArray
			},
			/**
			 *
			 */
			arrowDown() {
				if (this.selectedIndex >= this.dataList.length - 1) return
				this.selectedIndex++

				var tr = document.getElementById('tr_' + this.selectedIndex)
				var chk = document.getElementById('chk_' + this.selectedIndex)
				if (chk) {
					if (chk.offsetParent) {
						tr.scrollIntoView()
					}
				}
			},
			/**
			 *
			 */
			arrowUp() {
				if (this.selectedIndex <= 0) return
				this.selectedIndex--

				var tr = document.getElementById('tr_' + this.selectedIndex)
				var chk = document.getElementById('chk_' + this.selectedIndex)
				if (chk) {
					tr.scrollIntoView()
				}
			},
			/**
			 *
			 */
			tableFocus() {
				//console.log("tableFocus");
			},
			/**
			 *
			 */
			tableBlur() {
				//console.log("tableBlur");
			},
			/**
			 * 调用接口进行状态更新。
			 */
			updateStatus(status) {
				var self = this
				var statusValue = status ? 1 : 0

				//如果当前没有勾选缺陷信息，则更新当前选中的缺陷记录。
				var checkedCount = this.dataList.filter(t => t.checked).length
				if (checkedCount == 0) {
					var item = this.dataList[this.selectedIndex]
					item.status = statusValue

					getDefectRequest(this.batch_id)
						.modifyById(item._id.$oid, item)
						.then(res => {
							self.dataList.splice(this.selectedIndex, 1, item)
							self.items.splice(this.selectedIndex, 1, item)
							console.log('修改成功.', item)
						})
				} else {
					//更新勾选的缺陷记录。
					this.dataList.forEach((item, index) => {
						if (item.checked) {
							item.checked = false
							item.status = statusValue

							getDefectRequest(this.batch_id)
								.modifyById(item._id.$oid, item)
								.then(res => {
									self.dataList.splice(index, 1, item)

									var item2 = { ...item }
									item2.checked = undefined

									self.items.splice(index, 1, item2)
									console.log('修改成功.', item)
								})
						}
					})
				}

				//更新筛选状态。
				this.changeFilterStatus(1)
			},
			/**
			 * 更新为坏品。
			 */
			ineligible() {
				this.updateStatus(false)
			},
			/**
			 * 更新为好品
			 */
			eligible() {
				this.updateStatus(true)
			},
			/**
			 * 按类型进行查询。
			 */
			changeType(value) {
				this.dataList = []
				this.type = value
				this.pageIndex = 1
				this.loading = true
				if (!this.firstLoad) {
					this.initData()
				}
			},
			/**
			 * 按状态查询。
			 */
			changeStatus(value) {
				this.dataList = []
				this.status = value
				this.pageIndex = 1
				this.loading = true

				if (!this.firstLoad) {
					this.initData()
				}
			},
			/**
			 * 修改版图。
			 */
			changeSurface(value) {
				this.dataList = []
				this.loading = true
				this.firstLoad = true
				this.$emit('changeSurface', value)
			},
			/**
			 * 获取缺陷类型名称。
			 */
			getDefectTypeName(index, sys_index) {
				var defectType = this.defectTypes.find(t => t.value == index)
				if (defectType) {
					return defectType.label
				} else {
					defectType = this.defectTypes.find(t => t.value == sys_index)
					if (defectType) {
						return defectType.label
					}
				}

				return '--'
			},
			getModelSideText(index) {
				var obj = this.modelSides.find(t => t.side_index == index)
				if (obj) {
					return obj.name
				}

				return '--'
			},
			invokeShortcutKey() {
				var self = this
				document.onkeydown = function(e) {
					const key = window.event.keyCode
					if (key == 40) {
						//下移。
						self.arrowDown()
						e.preventDefault()
					} else if (key == 38) {
						//上移。
						self.arrowUp()
						e.preventDefault()
					} else if (key == 66) {
						if (self.selectedIndex > -1) {
							self.dataList[self.selectedIndex].checked = true
						}

						self.ineligible()
						e.preventDefault()
					} else if (key == 71) {
						if (self.selectedIndex > -1) {
							self.dataList[self.selectedIndex].checked = true
						}
						self.eligible()
					}
				}
			},
			changeFilterStatus(val) {
				this.$emit('changeFilterStatus', val)
			},
		},
		mounted() {
			//注册快捷键。
			this.invokeShortcutKey()

			if (this.itemCount > 0 && this.firstLoad) {
				this.initData()
			}

			// this.tableDom = document.getElementById('defect_list_table')
			// //滚动条监控。
			// var scrollDom = this.tableDom
			// scrollDom.onscroll = e => {
			// 	if (scrollDom.clientHeight + parseInt(scrollDom.scrollTop) === scrollDom.scrollHeight) {
			// 		if (!this.loading) {
			// 			console.log('加载...')
			// 			this.pageIndex++
			// 			this.initData()
			// 		}
			// 	}
			// }
		},
		created() {
			this.firstLoad = true
			this.loading = true

			defectTypeRequest.queryAll({ roll_id: this.batch_id }).then(res => {
				this.rollDefectTypes = res
			})
		},
	}
</script>

<style scoped>
	.table-header {
		border-top: 1px #ccc solid;
		border-right: 1px #ccc solid;
		border-left: 1px #ccc solid;
	}
	.table-list {
		width: 100%;
		border-collapse: collapse;
	}

	.table-list td,
	.table-list th {
		text-align: left;
		border-right: 1px #ccc solid;
		font-size: 12px;
	}

	.table-list th {
		padding: 2px 10px 5px 10px;
	}

	.table-list td {
		padding: 2px 10px;
	}

	.table-list tr.bad td {
		color: #f00;
	}

	.table-list thead th {
		background-color: #eee;
		border-right: none;
		font-weight: normal;
	}

	.table-list tbody tr:hover {
		background-color: #efefef;
	}

	.table-list tbody tr.checked {
		background-color: #f0f7ff;
	}

	.table-list tbody tr.active {
		background-color: #006ecc;
	}

	.table-list tbody tr.active td {
		border: none;
		color: #fff;
	}

	.list-container {
		position: absolute;
		right: 140px;
		left: 0;
		top: 0;
		bottom: 0;
	}

	.control-container {
		position: absolute;
		width: 120px;
		font-size: 10px;
		right: 10px;
		color: blue;
		top: 0;
		bottom: 0;
		overflow: auto;
	}

	.table-container {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 30px;
		overflow: auto;
		border: 1px #ccc solid;
		background-color: #fff;
	}

	.table-container table {
		border-top: none;
		border-right: none;
	}

	td.index label {
		color: #aaa;
		font-weight: normal;
	}

	.loading {
		position: absolute;
		left: 45%;
		background-color: #4a4a4ab8;
		text-align: center;
		padding: 10px 20px;
		color: #dadada;
		border-radius: 20px;
		top: 50px;
	}
</style>
